<template>
  <q-btn
    icon="filter_alt"
    :outline="filtersCount > 0 ? true : false"
    :style="{ 'color': filtersCount > 0 ? 'var(--q-primary)' : '' }"
  >
    <q-badge
      v-if="filtersCount > 0"
      :label="filtersCount"
      color="primary"
      size="xs"
      floating
    />
    <q-menu>
      <q-list
        style="min-width: 200px;"
      >
        <q-item
          class="column"
          clickable
        >
          <span class="text-caption">
            Batched
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': !filters.batched }"
          >
            {{ batchedLabel }}
          </span>
          <q-menu
            ref="borsBatchedMenu"
            anchor="top right"
          >
            <q-list>
              <q-item
                v-for="{ label, value } in batchedOptions"
                :key="`bors-filter-batched-${value}`"
                clickable
                @click="filters.batched = value; $refs.borsBatchedMenu.hide();"
              >
                <q-item-section>
                  <q-item-label>{{ label }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>
        <q-item
          class="column"
          clickable
        >
          <span class="text-caption">
            States
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': $_.isEmpty(filters.states) }"
          >
            {{ stateLabel }}
          </span>
          <q-menu
            ref="borsStateMenu"
            anchor="top right"
          >
            <q-list>
              <q-item
                v-for="{ label, value } in stateOptions"
                :key="value"
                clickable
                @click="filters.states = value === null ? [] : $_.xor(filters.states, [value])"
              >
                <q-item-section>
                  <q-item-label>{{ label }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>
        <q-item
          class="column"
          clickable
        >
          <span class="text-caption">
            Types
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': $_.isEmpty(filters.types) }"
          >
            {{ typeLabel }}
          </span>
          <q-menu
            ref="borsTypeMenu"
            anchor="top right"
          >
            <q-list>
              <q-item
                v-for="{ label, value } in typeOptions"
                :key="value"
                clickable
                @click="filters.types = value === null ? [] : $_.xor(filters.types, [value])"
              >
                <q-item-section>
                  <q-item-label>{{ label }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>
        <q-item
          class="column"
          clickable
        >
          <span class="text-caption">
            Weeks Of
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': $_.isEmpty(filters.weeksOf) }"
          >
            {{ weeksOfLabel }}
          </span>
          <q-menu
            ref="borsWeeksOfMenu"
            anchor="top right"
          >
            <q-date
              v-model="filters.weeksOf"
              multiple
              :options="isValidDate"
            />
          </q-menu>
        </q-item>
        <q-item
          class="column"
          clickable
          :disable="filters.disables.includes('sites')"
        >
          <span class="text-caption">
            Sites
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': $_.isEmpty(filters.sites) }"
          >
            {{ $_.isEmpty(filters.sites) ? 'All' : $_.map(filters.sites, 'name').join(', ') }}
          </span>
          <q-menu
            ref="borsSiteMenu"
            anchor="top right"
          >
            <q-list>
              <q-item
                v-for="{ label, value } in siteOptions"
                :key="`bors-filter-site-${value?.id}`"
                clickable
                @click="filters.sites = value === null ? [] : $_.xor(filters.sites, [value])"
              >
                <q-item-section>
                  <q-item-label>{{ label }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>
        <q-item
          class="column"
          clickable
          :disable="filters.disables.includes('studios')"
        >
          <span class="text-caption">
            Studios
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': $_.isEmpty(filters.studios) }"
          >
            {{ $_.isEmpty(filters.studios) ? 'All' : $_.map(filters.studios, 'name').join(', ') }}
          </span>
          <q-menu
            ref="borsStudioMenu"
            anchor="top right"
          >
            <q-list>
              <q-item>
                <q-item-section>
                  <q-input
                    v-model="filters.studioSearchString"
                    placeholder="Search Studios..."
                    :outlined="false"
                    borderless
                    dense
                    debounce="100"
                    clearable
                  />
                </q-item-section>
              </q-item>
              <q-item
                v-for="{ label, value } in studioOptions"
                :key="`bors-filter-studio-${value?.id}`"
                clickable
                @click="filters.studios = value === null ? [] : $_.xor(filters.studios, [value])"
              >
                <q-item-section>
                  <q-item-label>{{ label }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>
        <q-item
          class="column"
          clickable
          :disable="filters.disables.includes('movies')"
        >
          <span class="text-caption">
            Movies
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': $_.isEmpty(filters.movies) }"
          >
            {{ $_.isEmpty(filters.movies) ? 'All' : $_.map(filters.movies, 'name').join(', ') }}
          </span>
          <q-menu
            ref="borsMovieMenu"
            anchor="top right"
          >
            <q-list>
              <q-item>
                <q-item-section>
                  <q-input
                    v-model="filters.movieSearchString"
                    placeholder="Search Movies..."
                    :outlined="false"
                    borderless
                    dense
                    debounce="100"
                    clearable
                  />
                </q-item-section>
              </q-item>
              <q-item
                v-for="{ label, value } in movieOptions"
                :key="`bors-filter-movie-${value?.id}`"
                clickable
                @click="filters.movies = value === null ? [] : $_.xor(filters.movies, [value])"
              >
                <q-item-section>
                  <q-item-label>{{ label }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>
        <q-item
          class="column"
          clickable
          :disable="filters.disables.includes('movieTerms')"
        >
          <span class="text-caption">
            Movie Terms
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': $_.isEmpty(filters.movieTerms) }"
          >
            {{ $_.isEmpty(filters.movieTerms) ? 'All' : $_.map(filters.movieTerms, 'name').join(', ') }}
          </span>
          <q-menu
            ref="borsMovieTermMenu"
            anchor="top right"
          >
            <q-list>
              <q-item>
                <q-item-section>
                  <q-input
                    v-model="filters.movieTermSearchString"
                    placeholder="Search Movie Terms..."
                    :outlined="false"
                    borderless
                    dense
                    debounce="100"
                    clearable
                  />
                </q-item-section>
              </q-item>
              <q-item
                v-for="{ label, value } in movieTermOptions"
                :key="`bors-filter-movie-term-${value?.id}`"
                clickable
                @click="filters.movieTerms = value === null ? [] : $_.xor(filters.movieTerms, [value])"
              >
                <q-item-section>
                  <q-item-label>{{ label }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>
        <q-separator />
        <q-item
          class="row justify-between"
          dense
          :disable="filtersCount === 0"
          clickable
          @click="clearFilters"
        >
          <span class="text-caption text-bold q-my-auto">
            Clear Filters
          </span>
          <q-icon
            class="q-my-auto"
            name="filter_alt_off"
            dense
            flat
            round
          />
        </q-item>
      </q-list>
    </q-menu>
  </q-btn>
</template>

<script>

import { STATES, TYPES } from 'src/models/settlement/BoxOfficeReportSettlement'

const batchedOptions = [
  { label: 'All', value: null },
  { label: 'Batched', value: 'batched' },
  { label: 'Unbatched', value: 'unbatched' }
]

export default {
  name: 'BoxOfficeReportSettlementFilter',
  context: ['currentUser'],
  configuration: ['currentCircuit'],
  props: {
    filters: {
      type: Object,
      required: true
    },
    studios: {
      type: Array,
      required: true
    },
    movies: {
      type: Array,
      required: true
    },
    movieTerms: {
      type: Array,
      required: true
    }
  },
  computed: {
    batchedLabel () {
      return _.startCase(this.filters.batched) || 'All'
    },
    stateLabel () {
      return _(this.filters.states).map(state => _.startCase(state)).values().join(', ') || 'All'
    },
    typeLabel () {
      return _(this.filters.types).map(type => _.startCase(type)).values().join(', ') || 'All'
    },
    weeksOfLabel () {
      return _.isEmpty(this.filters.weeksOf) ? 'All' : _.map(this.filters.weeksOf, weekof => this.$i18n.d(new Date(weekof), 'shortDate')).join(', ')
    },
    filtersCount () {
      return this.$mh.objectToArray(this.filters, { testFn: (value) => { return !_.isEmpty(value) } }).length
    },
    siteOptions () {
      return _.concat(_.map(this.currentUser.authorizedSiteOptions, site => {
        return {
          label: site.name,
          value: site
        }
      }), { label: 'All', value: null })
    },
    studioOptions () {
      return _.concat(_.map(this.studios, studio => {
        return {
          label: studio.name,
          value: studio
        }
      }), { label: 'All', value: null })
    },
    movieOptions () {
      return _.concat(_.map(this.movies, movie => {
        return {
          label: movie.name,
          value: movie
        }
      }), { label: 'All', value: null })
    },
    movieTermOptions () {
      return _.concat(_.map(this.movieTerms, movieTerm => {
        return {
          label: movieTerm.name,
          value: movieTerm
        }
      }), { label: 'All', value: null })
    }
  },
  created () {
    _.extend(this, {
      batchedOptions,
      stateOptions: _.concat(this.$mh.asOptions(STATES.ALL), { label: 'All', value: null }),
      typeOptions: _.concat(this.$mh.asOptions(TYPES.ALL), { label: 'All', value: null })
    })
  },
  methods: {
    isValidDate (date) {
      return (new Date(date).getDay()) === this.currentCircuit.dayOfWeekStart
    },
    clearFilters () {
      _.each(this.filters, (value, key) => {
        if (_.isArray(value)) {
          this.filters[key] = []
        } else {
          this.filters[key] = null
        }
      })
    }
  }
}
</script>
